/* eslint-disable */
import noop from '../args/noop';
import isFunction from '../lodash/is_function';
import randomKey from '../random/random_key';
import {windows} from "../sysenv/windowsimulate";

/**
 * Options:
 *  - param {String} qs parameter (`callback`)
 *  - prefix {String} qs parameter (`bbo`)
 *  - name {String} qs parameter (`prefix` + incr)
 *  - timeout {Number} how long after a timeout error is emitted (`60000`)
 * @param {String} url
 * @param {Object|Function} optional options / callback
 * @param {Function} optional callback
 */

function jsonp(url, opts, fn) {
  if (isFunction(opts)) {
    fn = opts;
    opts = {};
  }
  if (!opts) opts = {};

  var prefix = opts.prefix || 'bbo';
  var id = opts.name || prefix + randomKey(10);

  var param = opts.param || 'callback';
  var timeout = null != opts.timeout ? opts.timeout : 60000;
  var enc = encodeURIComponent;
  var target = document.getElementsByTagName('script')[0] || document.head;
  var script;
  var timer;

  if (timeout) {
    timer = setTimeout(function() {
      cleanup();
      if (fn) fn(new Error('Timeout'));
    }, timeout);
  }

  function cleanup() {
    if (script.parentNode) script.parentNode.removeChild(script);
    windows[id] = noop();
    if (timer) clearTimeout(timer);
  }

  function cancel() {
    if (windows[id]) {
      cleanup();
    }
  }

  windows[id] = function(data) {
    cleanup();
    if (fn) fn(data, null);
  };

  url += (~url.indexOf('?') ? '&' : '?') + param + '=' + enc(id);
  url = url.replace('?&', '?');
  script = document.createElement('script');
  script.src = url;
  target.parentNode.insertBefore(script, target);

  return cancel;
}

export default jsonp;
